import {version} from './version';

export const environment = {
  api: 'https://api.xmedical.app',
  adminApi: 'https://api.xmedical.app/admin',
  production: true,
  serviceWorkerEnabled: true,
  authServer: 'https://accounts.xmedical.app/auth/realms/xmedical_app',
  clientId: 'xmedical-app',
  idleTimeout: 15 * 60 * 1000,
  showDebugInformation: false,
  scope: 'openid profile email offline_access',
  responseType: 'code',
  appTermsLink: 'https://cryptexmedical.com',
  appPrivacyLink: 'https://cryptexmedical.com',
  appSuperuserTermsLink: 'https://cryptexmedical.com',
  version: `${version}`,
  pusher: {
    key: '11dcf043dca34f3ec2cd',
    cluster: 'eu'
  },
  webPush: {
    enabled: true
  },
  sentryDsn: 'https://29d26ab15048de69cc971dcb086fa7b9@o4508377616285696.ingest.de.sentry.io/4511070093377616',
  sentryEnvironment: 'production',
  cognitoRegion: 'eu-west-1',
  cognitoIdentityPoolId: 'eu-west-1:8d6c815c-90de-4736-b10c-6eea0f1cbb05'
};
